export default import.meta.ROLLDOWN_FILE_URL_ZAES2HcfJ9sHdMfNSDSxmw